/******/ (() => { 
var __webpack_exports__ = {};
Shopify.theme.jsMegaMenu = {
  init: function($section) {
    Shopify.theme.jsMegaMenu = $.extend(this, Shopify.theme.getSectionData($section));

    const parentLink = this.parent_link;
    const sectionId = this.section_id;
    const $megaMenu = $section.find('.mega-menu__' + sectionId);
    const handle = (parentLink || '').toString().toLowerCase().replace(/\s+/g, '-');

    $(`.mega-menu__section[data-parent-handle="${handle}"]`).remove();

    /* ============= MOBILE CLONE ============= */
    const isMobile = window.matchMedia('(max-width: 798px)').matches;
    const $parentMobileElement = $(`[data-mobile-menu-navlink-handle="${handle}"]`);

    if(isMobile){

      return;

    }else{
              if($parentMobileElement.length) {
          if ($parentMobileElement.find('.has-no-submenu').length) {
            $parentMobileElement.find('a.mobile-menu__item').addClass('mobile-menu-link');
            $parentMobileElement.find('a').after('<span class="close-dropdown"></span>');
            $parentMobileElement.find('.submenu__label')
              .after('<ul class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>');
            $parentMobileElement.find('[data-mobile-menu-has-toggle]').attr('data-mobile-menu-has-toggle', true);
            $megaMenu.clone().appendTo($parentMobileElement.find('.has-mega-menu'));
          } else {
            let $list = $parentMobileElement.find('[data-mobile-submenu-first-level-list]');
            $list.empty().addClass('has-mega-menu').removeClass('has-dropdown');
            const $mobileMega = $megaMenu.clone();

            $mobileMega
              .addClass('mega-menu--mobile')
              .removeAttr('style'); 
                    $megaMenu.clone().appendTo($list);
          }
        }
    }
    
    const $header = $('#header');
    if (!$header.length || !$megaMenu.length) return;

    /* ============= DESKTOP CLONE ============= */
    const $clone = $megaMenu.clone();
    if (!$clone.length) return;

    $clone.attr('data-parent-handle', handle);
    $header.after($clone);

    $clone.css({
      display: 'none',
      position: 'fixed',
      left: 0,
      width: '100%',
      zIndex: 9999
    });

    /* ============= TOP POSITION FUNCTION ============= */
    function updateMegaMenuPosition() {
      const $announcement = $('.announcement-bar, .announcement, .announcement-sticky-wrapper');
      const aHeight = $announcement.outerHeight() || 0;
      const hHeight = $header.outerHeight() || 0;
      const scrollY = window.scrollY;

      let top = hHeight;

      if (scrollY < 10) {
        // sin scroll → +40px extra (requerimiento)
        top = aHeight + hHeight + 40;
      }

      $(`.mega-menu__section[data-parent-handle="${handle}"]`).css('top', `${top}px`);
    }

    updateMegaMenuPosition();
    $(window).on('scroll.megaMenuReposition resize.megaMenuReposition', updateMegaMenuPosition);

    /* ============= NAV HANDLERS ============= */
    const $parentElement = $(`[data-navlink-handle="${handle}"]`);
    const $parentElementLink = $parentElement.children('.header__link');

    if (
      $parentElement.length &&
      ($parentElement.hasClass('header__item') || $parentElement.hasClass('vertical-header__first-level'))
    ) {
      // Ocultar dropdown clásico
      $parentElement.find('.navbar-dropdown').addClass('is-invisible is-hidden');

      // 🔑 ESTA LÍNEA DEVUELVE LA FLECHA
      $parentElementLink.removeClass('is-arrowless');

      // Marca como mega menú
      $parentElement.addClass('has-mega-menu');
    }

    /* HOVER PARA DESKTOP */
    const openOnHover = $('.dropdown-click--false').length > 0;

    function showMega(handleShow) {
      $('.mega-menu__section').removeClass('is-active').hide();
      const $target = $(`.mega-menu__section[data-parent-handle="${handleShow}"]`);
      if ($target.length) {
        $target.addClass('is-active').show();
        updateMegaMenuPosition();
      }
    }

    function hideAllMega() {
      $('.mega-menu__section').removeClass('is-active').hide();
    }

    if (openOnHover) {
      // DESKTOP
      $('.navbar-item').on('mouseenter', function(){
        const h = $(this).data('navlink-handle');
        if (h) showMega(h.toLowerCase().replace(/\s+/g, '-'));
      });

      $('.mega-menu__section, .navbar').on('mouseleave', hideAllMega);

    } else {
      // MOBILE / CLICK
      $('.navbar-item').on('click', function(e){
        e.stopPropagation();
        hideAllMega();
        const h = $(this).data('navlink-handle');
        if (h) showMega(h.toLowerCase().replace(/\s+/g, '-'));
      });

      $(document).on('click', hideAllMega);
      $('.mega-menu__section').on('click', function(e){ e.stopPropagation(); });
    }

  },

  unload: function($section) {
    let parentLink = $section.find('.mega-menu').data('parent-link');
    let handle = (parentLink || '').toLowerCase().replace(/\s+/g, '-');
    $(window).off('scroll.megaMenuReposition resize.megaMenuReposition');
    $(`.mega-menu__section[data-parent-handle="${handle}"]`).remove();
  }
}
})()